import { useMemo } from "react";
import { buildSimpleColumns } from "../helpers/buildSimpleColumns";
import type { useDiscoverGamesColumnConfig } from "./useDiscoverGamesColumnConfig";
import type { useDiscoverGamesQuery } from "./useDiscoverGamesQuery";
import type { useDiscoverGamesViewState } from "./useDiscoverGamesViewState";

type ColConfig = ReturnType<typeof useDiscoverGamesColumnConfig>;
type View = ReturnType<typeof useDiscoverGamesViewState>;
type Query = ReturnType<typeof useDiscoverGamesQuery>;

export function useDiscoverGamesTableColumns(colConfig: ColConfig, view: View, query: Query) {
	return useMemo(
		() =>
			buildSimpleColumns({
				discoverGamesColumns: colConfig.discoverGamesColumns,
				columnOrder: view.columnOrder,
				columnWidths: view.columnWidths,
				groupColors: view.groupColors,
				items: query.items,
				sort: query.sort,
				handleSort: query.handleSort,
			}),
		[
			colConfig.discoverGamesColumns,
			view.columnOrder,
			view.columnWidths,
			view.groupColors,
			query.items,
			query.sort,
			query.handleSort,
		],
	);
}
